import { featureFlagClient, useFeatureFlag } from '@trello/feature-flag-client';
import { memberId } from '@trello/session-cookie';
import { idToDate } from '@trello/dates';

const CUTOFF_DATE = new Date('2019-12-18');

export const useAllUsersAreAdminsEnabled = (cutoffDate?: Date) => {
  const featureFlagEnabled = useFeatureFlag(
    'btg.all-users-are-admins.phase-1',
    false,
  );

  const newUser = idToDate(memberId!) >= (cutoffDate || CUTOFF_DATE);

  return featureFlagEnabled && newUser;
};

export const allUsersAreAdminsEnabled = (cutoffDate?: Date) => {
  const featureFlagEnabled = featureFlagClient.get(
    'btg.all-users-are-admins.phase-1',
    false,
  );

  const newUser = idToDate(memberId!) >= (cutoffDate || CUTOFF_DATE);

  return featureFlagEnabled && newUser;
};
